import React, { useState } from "react";
import { FaFacebookMessenger, FaComments, FaTimes } from "react-icons/fa";
import { SiZalo } from "react-icons/si";

const FloatingChatButton = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleChat = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="fixed bottom-6 right-6 flex flex-col items-end z-50 font-OpenSans">
            {/* Các nút Chat hiển thị khi mở */}
            {isOpen && (
                <div className="mb-3 flex flex-col space-y-2">
                    {/* Messenger */}
                    <a
                        href="https://m.me/your_facebook_username"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center space-x-3 px-4 py-2.5 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition duration-300"
                    >
                        <FaFacebookMessenger size={24} />
                        <span>Messenger</span>
                    </a>

                    {/* Zalo */}
                    <a
                        href="https://zalo.me/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center space-x-3 px-4 py-2 bg-orange-700 text-white rounded-full shadow-lg hover:bg-[#0077AA] transition duration-300"
                    >
                        <SiZalo size={30} />
                    </a>
                </div>
            )}

            {/* Nút mở Chat */}
            <button
                onClick={toggleChat}
                className="w-14 h-14 flex items-center justify-center bg-[#33367b] text-white rounded-full shadow-lg hover:bg-indigo-700 transition duration-300"
            >
                {isOpen ? <FaTimes size={24} /> : <FaComments size={24} />}
            </button>
        </div>
    );
};

export default FloatingChatButton;
